export enum OperationType {
  OPERATION = 'operation',
  GROUP = 'group'
}
